import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import api from '@board/api'

import ModalLayout from '@appbase/templates/ModalLayout/ModalLayout.vue'

@Component({
    components: {
        ModalLayout
    }
})
export default class PasswordCheck  extends Vue {
    @Prop({ type: Number }) articleId!: number;

    password: string = "";

    onConfirm() {
        api.article.checkArticlePassword({
            articleId: this.articleId,
            password: this.password
        }).then(res => {
            if(res) {
                this.$emit('confirm', this.password);
            } else {
                (window as any).alertAsync(this.$t('패스워드가_일치하지_않습니다_').toString());
            }
        });
    }

    onCancel() {
        this.password = "";
        this.$emit('cancel');
    }
}